const isBrowser = (): boolean => typeof document !== 'undefined';

export default isBrowser;